import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@mantine/core';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import dayjs from 'dayjs';
import { getUserResetPassword, getUsersResetPassword } from '../../../utils/storage';

const ModalReminderResetPassword = ({ onClose, open }) => {
  const users = getUsersResetPassword();
  const user = getUserResetPassword();
  const reset = users.find(({ email }) => email === user?.email);
  const DURATION = 300;
  const [countdown, setCountdown] = useState(DURATION);

  useEffect(() => {
    if (reset?.time) {
      const diff = dayjs().diff(dayjs(reset.time), 'second');
      const timeLeft = DURATION - diff;
      const duration = timeLeft > 0 ? timeLeft : 0;
      setCountdown(duration);
    }
  }, [reset, DURATION]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (countdown > 0) {
        setCountdown(countdown - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [countdown]);

  const displayCountdown = useCallback(
    (unit) => {
      const value =
        unit === 'minute'
          ? parseInt(countdown / 60, 10)
          : parseInt(countdown % 60, 10);
      return value < 10 ? `0${value}` : value;
    },
    [countdown]
  );

  return (
    <Modal centered onClose={onClose} opened={open} size="lg">
      <div className={styles.contentModal}>
        <h4>Perbarui Kata Sandi</h4>
        <hr className={styles.line} />
        {countdown <= 0 ? (
          <p>Silahkan tutup informasi ini untuk melanjutkan permintaan lupa kata sandi.</p>
        ): (
          <p>
          Anda telah melakukan permintaan lupa (memperbarui) kata sandi. Harap
          tunggu hingga{' '}
            <strong>
              {`${displayCountdown('minute')}:${displayCountdown('seconds')}`}
            </strong>
          </p>
        )}
      </div>
      <div className={styles.modalAction}>
        <Button onClick={onClose} style={'blue'} type="button">
          Tutup
        </Button>
      </div>
    </Modal>
  );
};

export default ModalReminderResetPassword;

ModalReminderResetPassword.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
